/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Model-layer boundary re-exports of the `@tivocorp/data-domain-lib` DTOs
 * consumed by the Content Detail feature's mapper.
 *
 * Per ai_docs/REDUX_GOVERNANCE.md section 6.1, the viewModel layer must not
 * import `@tivocorp/data-domain-lib` directly — only `../../model/types/`,
 * `../../model/interfaces/`, etc. This file is that single, named entry
 * point for Content Detail: it is the only place that imports these DTOs
 * from the package, so the viewModel layer can depend on the model layer
 * instead of the external package directly.
 */

export {
  ActionKernelType,
  ActionType,
  ContentScreenType,
  DetailType,
  UnifiedCollectionDetailType
} from "@tivocorp/data-domain-lib/client-code/actions";
export { ActionType as VodOttActionType } from "@tivocorp/data-domain-lib/client-code/action-details";
export { OptionType as RecordingOptionType } from "client-code/cloudcore-recordings";
export { RecordingStatusV2 } from "client-code/recordings-status";
export type {
  Action,
  ContentScreenDetails
} from "@tivocorp/data-domain-lib/client-code/actions";
export type {
  TPreview,
  TUnifiedCollectionScreenDetails
} from "@tivocorp/data-domain-lib";

export const CONTENT_DETAIL_SEED_TYPE = {
  CONTENT_ID: "contentId",
  UNIFIED_COLLECTION_ID: "unifiedCollectionId",
  OFFER_ID: "offerId",
  RECORDING_ID: "recordingId",
  VOD_OFFER_ID: "vodOfferId"
} as const;

/**
 * Explore-section response DTOs — the episode-guide and upcoming-offers
 * services behind the "Episodes" and "Upcoming" sections.
 */
export type {
  EpisodeInfo,
  SeasonInfo,
  SeasonsData,
  UpcomingOfferListV2,
  UpcomingOfferV2
} from "@tivocorp/data-domain-lib";
